import { useState } from 'react';

import type { IActiveBalance } from '@app/dashboard/types/innerLayout/balance_and_transfers/balance';

import Overview from './Overview';
import RecentTransfers from './RecentTransfers';

import styles from './balance.module.scss';

const Balance = () => {
  const [activeBalance, setActiveBalance] = useState<IActiveBalance | null>(
    null
  );

  return (
    <div className={styles['balance']}>
      <Overview
        activeBalance={activeBalance}
        setActiveBalance={setActiveBalance}
      />
      <RecentTransfers activeBalance={activeBalance} />
    </div>
  );
};

export default Balance;
